import type {ReactElement} from 'react'
// Components
import GroupList from '../group-list'
// Types
import type {Ballot, BallotPageBlock, ParentCategory} from '../../types/ballot'

interface GroupListBlockProps {
  ballot: Ballot
  block: BallotPageBlock
}

const getGroups = (ballot: Ballot, block: BallotPageBlock): ParentCategory[] => {
  const selectedGroups = block.formValuesObject.blockSelectedGroup

  if (selectedGroups && selectedGroups.length > 0) {
    return selectedGroups
  }

  return ballot.parent_categories
}

const GroupListBlock = ({ballot, block}: GroupListBlockProps): ReactElement | null => {
  const groups = getGroups(ballot, block)

  if (groups.length <= 0) return null

  return (
    <GroupList
      groups={groups}
      currentGroup={null}
      title={block.formValuesObject.blockTitle || 'Select a group'}
    />
  )
}

export default GroupListBlock
